<template>
  <div>
    <ExtEnvComponent></ExtEnvComponent>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CForm inline>
              <label class="col-form-label ml-2 mr-2">검색조건</label>
              <CSelect
                :value.sync="inFacilityId"
                :options="inFacilityList"
                style="margin-bottom: 0; width: 97%"
                class="ml-2 ml-sm-0 w-auto-sm"
              >
              </CSelect>

              <div
                role="group"
                class="form-group form-row ml-2 mt-2 mt-sm-0 w-100 w-auto-sm"
              >
                <v-date-picker
                  v-model="searchAtRange"
                  is-range
                  :max-date="getMaxDate()"
                  :masks="{ title: 'YYYY년 MMM', L: 'YYYY-MM-DD' }"
                  class="w-100"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <div class="w-100 flex justify-center items-center">
                      <input
                        :value="inputValue.start"
                        v-on="inputEvents.start"
                        class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                        style="height: 35px; width: 47%"
                      />
                      ~
                      <input
                        :value="inputValue.end"
                        v-on="inputEvents.end"
                        class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                        style="height: 35px; width: 47%"
                      />
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CTabs :active-tab.sync="tab">
              <CTab title="실내부" active>
                <div class="p-2">
                  <div
                    ref="inEnvTempChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.inEnv.temp == null ||
                      chart.inEnv.temp.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>
                  <div
                    ref="inEnvHumidityChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.inEnv.humidity == null ||
                      chart.inEnv.humidity.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>
                  <div
                    ref="inEnvCo2Chart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.inEnv.co2 == null ||
                      chart.inEnv.co2.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>
                  <div
                    ref="inEnvSolarRadiationChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.inEnv.solarRadiation == null ||
                      chart.inEnv.solarRadiation.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>
                  <!--                  <div-->
                  <!--                    ref="inEnvChart"-->
                  <!--                    style="width: 100%; height: 400px"-->
                  <!--                    :class="-->
                  <!--                      chart.inEnv == null || chart.inEnv.data.length === 0-->
                  <!--                        ? 'd-none'-->
                  <!--                        : ''-->
                  <!--                    "-->
                  <!--                  ></div>-->
                  <div
                    style="
                      width: 100%;
                      height: 400px;
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                      text-align: center;
                      font-weight: bold;
                      font-size: 150%;
                      color: #ff0d0d;
                    "
                    v-if="
                      chart.inEnv.temp == null ||
                      chart.inEnv.temp.data.length === 0
                    "
                  >
                    <div>
                      <i class="fa fa-times-circle" aria-hidden="true"></i>
                      데이터 없음
                    </div>
                  </div>
                </div>
              </CTab>
              <CTab title="근권부">
                <div class="p-2">
                  <div
                    ref="rootEnvTempChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.rootEnv.temp == null ||
                      chart.rootEnv.temp.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>
                  <div
                    ref="rootEnvHumidityChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.rootEnv.humidity == null ||
                      chart.rootEnv.humidity.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>
                  <div
                    ref="rootEnvDrainageEcChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.rootEnv.drainageEc == null ||
                      chart.rootEnv.drainageEc.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>
                  <div
                    ref="rootEnvDrainagePhChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.rootEnv.drainagePh == null ||
                      chart.rootEnv.drainagePh.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>
                  <div
                    style="
                      width: 100%;
                      height: 400px;
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                      text-align: center;
                      font-weight: bold;
                      font-size: 150%;
                      color: #ff0d0d;
                    "
                    v-if="
                      chart.rootEnv.temp == null ||
                      chart.rootEnv.temp.data.length === 0
                    "
                  >
                    <div>
                      <i class="fa fa-times-circle" aria-hidden="true"></i>
                      데이터 없음
                    </div>
                  </div>
                </div>
              </CTab>
              <CTab title="양액부">
                <div class="p-2">
                  <div
                    ref="nutrientSolutionEcChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.nutrientSolution.ec == null ||
                      chart.nutrientSolution.ec.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>

                  <div
                    ref="nutrientSolutionPhChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.nutrientSolution.ph == null ||
                      chart.nutrientSolution.ph.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>

                  <div
                    ref="nutrientSolutionFlowRateChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.nutrientSolution.flowRate == null ||
                      chart.nutrientSolution.flowRate.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>

                  <div
                    ref="nutrientSolutionConstConcenChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.nutrientSolution.constConcen == null ||
                      chart.nutrientSolution.constConcen.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>

                  <div
                    style="
                      width: 100%;
                      height: 400px;
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                      text-align: center;
                      font-weight: bold;
                      font-size: 150%;
                      color: #ff0d0d;
                    "
                    v-if="
                      chart.nutrientSolution.ec == null ||
                      chart.nutrientSolution.ec.data.length === 0
                    "
                  >
                    <div>
                      <i class="fa fa-times-circle" aria-hidden="true"></i>
                      데이터 없음
                    </div>
                  </div>
                </div>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import core from "@/core";
import SensorService from "@/services/sensor/sensor.service";
import store from "@/store";
import ExtEnvComponent from "@/components/monitoring/ExtEnvComponent";
import MixinsInFacility from "@/mixins/in-facility";

export default {
  name: "Area",
  components: { ExtEnvComponent },
  mixins: [MixinsInFacility()],
  data() {
    return {
      tab: 0,
      chart: {
        inEnv: {
          sensorKeyList: ["temp", "humidity", "co2", "solarRadiation"],
          ready: false,
          temp: null,
          humidity: null,
          co2: null,
          solarRadiation: null,
        },
        rootEnv: {
          sensorKeyList: ["temp", "humidity", "drainageEc", "drainagePh"],
          ready: false,
          temp: null,
          humidity: null,
          drainageEc: null,
          drainagePh: null,
        },
        nutrientSolution: {
          sensorKeyList: ["ec", "ph", "flowRate", "constConcen"],
          ready: false,
          ec: null,
          ph: null,
          flowRate: null,
          constConcen: null,
        },
      },
      searchAtRange: {
        start: core.date.instance().add(-1, "days").toDate(),
        end: new Date(),
      },
    };
  },
  watch: {
    tab() {
      console.log(this.tab);
      this.getSensorData();
    },
    searchAtRange() {
      this.getSensorData();
    },
    inFacilityId() {
      const inFacilityId = this.inFacilityId;
      if (inFacilityId != null) {
        this.getSensorData();
      }
    },
  },
  methods: {
    getPreWeekAvg(daySize, preWeekList, preWeekStartAt, sensorKeyList) {
      const dayItemMap = new Map();
      // 일주일 평균 데이터 생성
      for (let i = 0; i < daySize; i++) {
        let dayItem = dayItemMap.get(i);
        if (dayItem == null) {
          dayItem = new Map();
          dayItemMap.set(i, dayItem);
        }
        const preWeekStartMoment = core.date
          .instance(preWeekStartAt)
          .add(i, "days");

        preWeekList.forEach((inEnv) => {
          const sensingMoment = core.date.instance(inEnv.sensingAt);
          const days = core.date
            .duration(
              core.date
                .instance(sensingMoment.format("YYYY-MM-DD 00:00:00"))
                .diff(
                  core.date.instance(
                    preWeekStartMoment.format("YYYY-MM-DD 00:00:00"),
                  ),
                ),
            )
            .asDays();
          if (days < 7) {
            const strTime = sensingMoment.format("HH:mm:ss");
            let item = dayItem.get(strTime);
            if (item == null) {
              item = {
                list: [],
                avg: null,
              };
              dayItem.set(strTime, item);
            }
            item.list.push(inEnv);
          }
        });
      }

      // 날짜별 평균값 계산
      dayItemMap.forEach((dayItem, key, map) => {
        dayItem.forEach((timeItem, key) => {
          //console.log("key : ", key);
          if (timeItem.avg == null) {
            timeItem.avg = {};
            sensorKeyList.forEach((sensorKey) => {
              timeItem.avg[sensorKey] = null;
              const upperKey =
                sensorKey.charAt(0).toUpperCase() + sensorKey.slice(1);
              timeItem.avg["min" + upperKey] = null;
              timeItem.avg["max" + upperKey] = null;
            });
          }

          timeItem.list.forEach((sensorItem) => {
            sensorKeyList.forEach((sensorKey) => {
              const upperKey =
                sensorKey.charAt(0).toUpperCase() + sensorKey.slice(1);

              if (timeItem.avg[sensorKey] == null) {
                timeItem.avg[sensorKey] = sensorItem[sensorKey];
                timeItem.avg["count" + upperKey] = 1;
              } else if (sensorItem[sensorKey] != null) {
                timeItem.avg[sensorKey] += sensorItem[sensorKey];
                timeItem.avg["count" + upperKey]++;
              }

              let key = null;

              key = "min" + upperKey;
              if (timeItem.avg[key] == null) {
                timeItem.avg[key] = sensorItem[key];
              } else if (timeItem.avg[key] > sensorItem[key]) {
                timeItem.avg[key] = sensorItem[key];
              }

              key = "max" + upperKey;
              if (timeItem.avg[key] == null) {
                timeItem.avg[key] = sensorItem[key];
              } else if (timeItem.avg[key] < sensorItem[key]) {
                timeItem.avg[key] = sensorItem[key];
              }
            });
          });
          sensorKeyList.forEach((sensorKey) => {
            if (timeItem.avg[sensorKey] != null) {
              const upperKey =
                sensorKey.charAt(0).toUpperCase() + sensorKey.slice(1);
              timeItem.avg[sensorKey] = Number(
                (
                  timeItem.avg[sensorKey] / timeItem.avg["count" + upperKey]
                ).toFixed(2),
              );
            }
          });
        });
      });
      console.log("dayItemMap : ", dayItemMap);
      return dayItemMap;
    },
    async getSensorData() {
      console.log("getSensorData");
      const inFacilityId = this.inFacilityId;
      if (inFacilityId != null) {
        core.loader.show();

        const standardMoment = core.date.instance(this.searchAtRange.start);
        const endMoment = core.date
          .instance(this.searchAtRange.end)
          .add(1, "days");

        console.log("standardMoment : ", standardMoment.format("YYYY-MM-DD"));

        // 일주일 전 평균값 조회
        const preWeekStartMoment = core.date
          .instance(standardMoment)
          .add(-7, "days");
        const preWeekEndMoment = core.date.instance(endMoment).add(-1, "days");

        if (this.tab === 0) {
          const chart = this.chart.inEnv;
          if (!chart.ready) {
            this.createInEnvChart();
            chart.ready = true;
          }
          this.getChartData(
            chart,
            SensorService.getInEnvAvgList,
            standardMoment,
            endMoment,
            preWeekStartMoment,
            preWeekEndMoment,
          );
        } else if (this.tab === 1) {
          const chart = this.chart.rootEnv;
          if (!chart.ready) {
            this.createRootEnvChart();
            chart.ready = true;
          }
          this.getChartData(
            chart,
            SensorService.getRootEnvAvgList,
            standardMoment,
            endMoment,
            preWeekStartMoment,
            preWeekEndMoment,
          );
        } else if (this.tab === 2) {
          const chart = this.chart.nutrientSolution;
          if (!chart.ready) {
            this.createNutrientSolutionChart();
            chart.ready = true;
          }

          this.getChartData(
            chart,
            SensorService.getNutrientSolutionAvgList,
            standardMoment,
            endMoment,
            preWeekStartMoment,
            preWeekEndMoment,
          );
        } else {
          console.log("Unknown tab : ", this.tab);
        }
        core.loader.hide();
      }
    },
    async getChartData(
      chart,
      getListFunction,
      standardMoment,
      endMoment,
      preWeekStartMoment,
      preWeekEndMoment,
    ) {
      const inFacilityId = this.inFacilityId;
      if (inFacilityId != null) {
        let daySize = core.date
          .duration(endMoment.diff(standardMoment))
          .asDays();
        console.log("daySize : ", daySize);

        const preWeekList = await getListFunction({
          inFacilityId: inFacilityId,
          type: "H",
          sensingAtGreaterThanEqual: preWeekStartMoment.format("YYYY-MM-DD"),
          sensingAtLessThan: preWeekEndMoment.format("YYYY-MM-DD"),
        });

        const sensorKeyList = chart.sensorKeyList;
        const dayItemMap = this.getPreWeekAvg(
          daySize,
          preWeekList,
          preWeekStartMoment.format("YYYY-MM-DD 00:00:00"),
          sensorKeyList,
        );

        const list = await getListFunction({
          inFacilityId: inFacilityId,
          type: "H",
          sensingAtGreaterThanEqual: standardMoment.format("YYYY-MM-DD"),
          sensingAtLessThan: endMoment.add(1, "days").format("YYYY-MM-DD"),
        });

        const sensorExistsMap = new Map();
        list.forEach((sensor) => {
          const sensingMoment = core.date.instance(sensor.sensingAt);
          sensor.date = sensingMoment.toDate();

          const days = core.date
            .duration(
              core.date
                .instance(sensingMoment.format("YYYY-MM-DD 00:00:00"))
                .diff(
                  core.date.instance(
                    standardMoment.format("YYYY-MM-DD 00:00:00"),
                  ),
                ),
            )
            .asDays();
          const dayItem = dayItemMap.get(days);
          if (dayItem == null) {
            console.log("not found dayItem! ", days);
          } else {
            const strTime = sensingMoment.format("HH:00:00");
            const timeItem = dayItem.get(strTime);
            if (timeItem == null) {
              console.log("not found timeItem! ", strTime);
            } else {
              sensorKeyList.forEach((sensorKey) => {
                const upperKey =
                  sensorKey.charAt(0).toUpperCase() + sensorKey.slice(1);
                let key = null,
                  preWeekKey = null;
                key = "min" + upperKey;
                preWeekKey =
                  "preWeek" + key.charAt(0).toUpperCase() + key.slice(1);
                sensor[preWeekKey] = timeItem.avg[key];

                key = "max" + upperKey;
                preWeekKey =
                  "preWeek" + key.charAt(0).toUpperCase() + key.slice(1);
                sensor[preWeekKey] = timeItem.avg[key];
                if (sensor[sensorKey] != null) {
                  sensorExistsMap.set(sensorKey, true);
                }
              });
              //console.log(sensor);
            }
          }
        });

        chart.sensorKeyList.forEach((sensorKey) => {
          chart[sensorKey].data = [];
        });

        sensorExistsMap.forEach((sensorData, key) => {
          chart[key].data = list;
        });
      }
    },
    getMaxDate() {
      return core.date.instance().add(1, "days").toDate();
    },
    createChart(params) {
      // {
      //   $el: null,
      //     columns: [
      //   {fieldName: "temp", name: "온도", unit: "℃", colorHex: "#ff6600"},
      //   {fieldName: "humidity", name: "습도", unit: "%", colorHex: "#1495ff"},
      //   {fieldName: "co2", name: "co2", unit: "ppm", colorHex: "#82ff14"},
      //   {fieldName: "co2", name: "co2", unit: "ppm", colorHex: "#82ff14"},
      // ],
      // }

      const chart = core.amchart.createXYDateChart(params.$el);
      const seriesList = [];
      const dateFieldName = "date";
      // const toggleAllSeries = core.amchart.createSeries(
      //   chart,
      //   "void",
      //   dateFieldName,
      //   "Toggle All",
      //   "#3e3e3e",
      // );
      // toggleAllSeries.events.on("hidden", function () {
      //   seriesList.forEach((series) => {
      //     series.hide();
      //   });
      // });
      // toggleAllSeries.events.on("shown", function () {
      //   seriesList.forEach((series) => {
      //     series.show();
      //   });
      // });
      params.columns.forEach((column) => {
        if (column.openFieldName != null) {
          const series = core.amchart.createRangeLineSeries(
            chart,
            column.openFieldName,
            column.fieldName,
            dateFieldName,
            column.name,
            column.colorHex,
            column.unit,
          );
          seriesList.push(series);
        } else {
          const series = core.amchart.createLineSeries(
            chart,
            column.fieldName,
            dateFieldName,
            column.name,
            column.colorHex,
            column.unit,
          );
          seriesList.push(series);
        }
      });

      const scrollbarX = new am4core.Scrollbar();
      // chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = scrollbarX;

      chart.data = null;
      return chart;
    },
    createInEnvChart() {
      this.chart.inEnv.temp = this.createChart({
        $el: this.$refs.inEnvTempChart,
        columns: [
          {
            openFieldName: "preWeekMinTemp",
            fieldName: "preWeekMaxTemp",
            name: "온도",
            unit: "℃",
            colorHex: "#ffbe7a",
          },
          { fieldName: "temp", name: "온도", unit: "℃", colorHex: "#FF6600" },
        ],
      });
      let title = this.chart.inEnv.temp.titles.create();
      title.text = "온도";
      title.fontSize = 25;

      this.chart.inEnv.humidity = this.createChart({
        $el: this.$refs.inEnvHumidityChart,
        columns: [
          {
            openFieldName: "preWeekMinHumidity",
            fieldName: "preWeekMaxHumidity",
            name: "습도",
            unit: "%",
            colorHex: "#ffbe7a",
          },
          {
            fieldName: "humidity",
            name: "습도",
            unit: "%",
            colorHex: "#FF6600",
          },
        ],
      });
      title = this.chart.inEnv.humidity.titles.create();
      title.text = "습도";
      title.fontSize = 25;

      this.chart.inEnv.co2 = this.createChart({
        $el: this.$refs.inEnvCo2Chart,
        columns: [
          {
            openFieldName: "preWeekMinCo2",
            fieldName: "preWeekMaxCo2",
            name: "co2",
            unit: "",
            colorHex: "#ffbe7a",
          },
          { fieldName: "co2", name: "co2", unit: "ppm", colorHex: "#FF6600" },
        ],
      });
      title = this.chart.inEnv.co2.titles.create();
      title.text = "co2";
      title.fontSize = 25;

      this.chart.inEnv.solarRadiation = this.createChart({
        $el: this.$refs.inEnvSolarRadiationChart,
        columns: [
          {
            openFieldName: "preWeekMinSolarRadiation",
            fieldName: "preWeekMaxSolarRadiation",
            name: "일사량",
            unit: "",
            colorHex: "#ffbe7a",
          },
          {
            fieldName: "solarRadiation",
            name: "일사량",
            unit: "",
            colorHex: "#FF6600",
          },
        ],
      });
      title = this.chart.inEnv.solarRadiation.titles.create();
      title.text = "일사량";
      title.fontSize = 25;
    },
    createRootEnvChart() {
      this.chart.rootEnv.temp = this.createChart({
        $el: this.$refs.rootEnvTempChart,
        columns: [
          {
            openFieldName: "preWeekMinTemp",
            fieldName: "preWeekMaxTemp",
            name: "온도",
            unit: "℃",
            colorHex: "#ffbe7a",
          },
          { fieldName: "temp", name: "온도", unit: "℃", colorHex: "#FF6600" },
        ],
      });
      let title = this.chart.rootEnv.temp.titles.create();
      title.text = "온도";
      title.fontSize = 25;

      this.chart.rootEnv.humidity = this.createChart({
        $el: this.$refs.rootEnvHumidityChart,
        columns: [
          {
            openFieldName: "preWeekMinHumidity",
            fieldName: "preWeekMaxHumidity",
            name: "습도",
            unit: "%",
            colorHex: "#ffbe7a",
          },
          {
            fieldName: "humidity",
            name: "습도",
            unit: "%",
            colorHex: "#FF6600",
          },
        ],
      });
      title = this.chart.rootEnv.humidity.titles.create();
      title.text = "습도";
      title.fontSize = 25;

      this.chart.rootEnv.drainageEc = this.createChart({
        $el: this.$refs.rootEnvDrainageEcChart,
        columns: [
          {
            openFieldName: "preWeekMinDrainageEc",
            fieldName: "preWeekMaxDrainageEc",
            name: "배액EC",
            unit: "",
            colorHex: "#ffbe7a",
          },
          {
            fieldName: "drainageEc",
            name: "배액EC",
            unit: "",
            colorHex: "#FF6600",
          },
        ],
      });
      title = this.chart.rootEnv.drainageEc.titles.create();
      title.text = "배액EC";
      title.fontSize = 25;

      this.chart.rootEnv.drainagePh = this.createChart({
        $el: this.$refs.rootEnvDrainagePhChart,
        columns: [
          {
            openFieldName: "preWeekMinDrainagePh",
            fieldName: "preWeekMaxDrainagePh",
            name: "배액PH",
            unit: "",
            colorHex: "#ffbe7a",
          },
          {
            fieldName: "drainagePh",
            name: "배액PH",
            unit: "",
            colorHex: "#FF6600",
          },
        ],
      });
      title = this.chart.rootEnv.drainagePh.titles.create();
      title.text = "배액PH";
      title.fontSize = 25;
    },
    createNutrientSolutionChart() {
      const chart = this.chart.nutrientSolution;
      chart.ec = this.createChart({
        $el: this.$refs.nutrientSolutionEcChart,
        columns: [
          {
            openFieldName: "preWeekMinEc",
            fieldName: "preWeekMaxEc",
            name: "EC",
            unit: "",
            colorHex: "#ffbe7a",
          },
          { fieldName: "ec", name: "EC", unit: "", colorHex: "#FF6600" },
        ],
      });
      let title = chart.ec.titles.create();
      title.text = "EC";
      title.fontSize = 25;

      chart.ph = this.createChart({
        $el: this.$refs.nutrientSolutionPhChart,
        columns: [
          {
            openFieldName: "preWeekMinPh",
            fieldName: "preWeekMaxPh",
            name: "PH",
            unit: "",
            colorHex: "#ffbe7a",
          },
          {
            fieldName: "ph",
            name: "PH",
            unit: "",
            colorHex: "#FF6600",
          },
        ],
      });
      title = chart.ph.titles.create();
      title.text = "PH";
      title.fontSize = 25;

      chart.flowRate = this.createChart({
        $el: this.$refs.nutrientSolutionFlowRateChart,
        columns: [
          {
            openFieldName: "preWeekMinFlowRate",
            fieldName: "preWeekMaxFlowRate",
            name: "공급유량",
            unit: "",
            colorHex: "#ffbe7a",
          },
          {
            fieldName: "flowRate",
            name: "공급유량",
            unit: "",
            colorHex: "#FF6600",
          },
        ],
      });
      title = chart.flowRate.titles.create();
      title.text = "공급유량";
      title.fontSize = 25;

      chart.constConcen = this.createChart({
        $el: this.$refs.nutrientSolutionConstConcenChart,
        columns: [
          {
            openFieldName: "preWeekMinConstConcen",
            fieldName: "preWeekMaxConstConcen",
            name: "공급성분농도",
            unit: "",
            colorHex: "#ffbe7a",
          },
          {
            fieldName: "constConcen",
            name: "공급성분농도",
            unit: "",
            colorHex: "#FF6600",
          },
        ],
      });
      title = chart.constConcen.titles.create();
      title.text = "공급성분농도";
      title.fontSize = 25;

      // if (true) return;
      // const $el = this.$refs.nutrientSolutionChart;
      // const chart = core.amchart.createXYDateChart($el);
      //
      // const seriesList = [];
      // const dateFieldName = "date";
      // const toggleAllSeries = core.amchart.createSeries(
      //   chart,
      //   "void",
      //   dateFieldName,
      //   "Toggle All",
      //   "#3e3e3e",
      // );
      // toggleAllSeries.events.on("hidden", function () {
      //   seriesList.forEach((series) => {
      //     series.hide();
      //   });
      // });
      // toggleAllSeries.events.on("shown", function () {
      //   seriesList.forEach((series) => {
      //     series.show();
      //   });
      // });
      // const series1 = core.amchart.createSeries(
      //   chart,
      //   "ec",
      //   dateFieldName,
      //   "EC",
      //   "#ff6600",
      //   "",
      // );
      // seriesList.push(series1);
      // const series2 = core.amchart.createSeries(
      //   chart,
      //   "ph",
      //   dateFieldName,
      //   "PH",
      //   "#1495ff",
      //   "",
      // );
      // seriesList.push(series2);
      // const series3 = core.amchart.createSeries(
      //   chart,
      //   "flowRate",
      //   dateFieldName,
      //   "공급유량",
      //   "#82ff14",
      //   "",
      // );
      // seriesList.push(series3);
      // const series4 = core.amchart.createSeries(
      //   chart,
      //   "constConcen",
      //   dateFieldName,
      //   "공급성분농도",
      //   "#ad14ff",
      //   "",
      // );
      // seriesList.push(series4);
      //
      // const scrollbarX = new am4core.Scrollbar();
      // chart.legend = new am4charts.Legend();
      // chart.cursor = new am4charts.XYCursor();
      // chart.scrollbarX = scrollbarX;
      //
      // chart.data = null;
      //
      // this.chart.nutrientSolution = chart;
    },
  },
};
</script>
